import { decimals } from './format';
import { m } from '../paraglide/messages';

/** Routing-redundancy copy driven by the gateway's catalog projection.
 *
 *  Every "this fails over" claim the UI makes comes from the authoritative
 *  `failover` field. The frontend never infers routing from lane count.
 */

/** A catalog entry as far as routing redundancy is concerned. */
export interface RoutingFacts {
  /** The gateway's authoritative answer. */
  failover: boolean;
}

/** True only when the gateway advertises automatic failover. */
export const hasFailover = (facts: RoutingFacts): boolean => facts.failover;

/** Compact routing label, e.g. `2 lanes · auto failover` or `1 lane · no failover`.
 *  States the single-lane case plainly: a customer planning around reliability is
 *  worse off with a vague answer than with an unflattering one. */
export const routingLabel = (laneCount: number, failover: boolean): string => {
  const count = decimals(laneCount, 0);
  if (laneCount === 1) return (failover ? m.dashfix_routing_one_failover : m.dashfix_routing_one_no_failover)({ count });
  return (failover ? m.dashfix_routing_other_failover : m.dashfix_routing_other_no_failover)({ count });
};
